import * as React from 'react';
import { Button } from '@/components/ui/button';
import {
  Card,
  CardContent,
  CardFooter,
  CardHeader,
} from '@/components/ui/card';
import { Progress } from '@/components/ui/progress';
import { Separator } from '@/components/ui/separator';
import { Pencil, ArrowRight, Edit2 } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export default function FormContainer({
  title,
  progress,
  missingFields,
  index,
}) {
  const navigate = useNavigate();
  const handleCompleteNow = () => {
    // Map form titles to their corresponding section IDs
    const formToSectionMap = {
      'Basic Information': 1,
      'Company Details': 2,
      'Technical Details': 3,
      'Upload Certificates': 4,
      'Refrences & Testimonials': 5,
      'Plant Information': 6,
      'Machines Information': 7,
    };

    const sectionId = formToSectionMap[title];
    if (sectionId) {
      navigate('/supplier/register', {
        state: {
          sectionId,
          fromDashboard: true,
        },
      });
    }
  };
  // Function to truncate missing fields to fit in two lines
  const formatMissingFields = (fields) => {
    return fields.length > 4
      ? `${fields.slice(0, 4).join(', ')}...`
      : fields.join(', ');
  };

  return (
    <Card className="w-full relative justify-between flex flex-col">
      {/* Edit Icon (only shows when progress is 100%) */}
      {progress === 100 && (
        <div
          className="absolute top-2 right-2 p-2 bg-white border border-gray-400/40 group hover:bg-lightPurple/20 rounded group"
          onClick={handleCompleteNow}
        >
          {/* <Pencil size={16} className="text-gray-500 cursor-pointer" /> */}

          <Edit2
            size={16}
            className=" transition-transform duration-500 group-hover:rotate-360 cursor-pointer"
          />
        </div>
      )}

      {/* Card Header */}

      {/* <CardHeader className="flex flex-row items-center gap-2">
        {progress === 100 ? (
          <span className="text-xl h-14 font-semibold text-darkPurple">
            COMPLETED!
          </span>
        ) : (
          <>
            <span className="text-sm font-light text-gray-500">
              {Math.round(progress)}%
            </span>
            <Progress
              value={progress}
              className="h-0.5 flex-grow bg-darkPurple/20"
              indicatorClassName="bg-darkPurple"
            />
          </>
        )}
      </CardHeader> */}
      <CardHeader className="flex flex-row items-center gap-2">
        {title !== 'Plant Information' && title !== 'Machines Information' ? (
          progress === 100 ? (
            <span className="text-xl h-14 font-semibold text-darkPurple">
              COMPLETED!
            </span>
          ) : (
            <>
              <span className="text-sm font-light text-gray-500">
                {Math.round(progress)}%
              </span>
              <Progress
                value={progress}
                className="h-0.5 flex-grow bg-darkPurple/30  before:absolute before:inset-0 before:bg-gradient-to-r before:from-transparent before:via-white/30 before:to-transparent before:translate-x-[-100%] group-hover:before:translate-x-[100%] before:transition-transform before:duration-1000 before:ease-in-out before:transform relative overflow-hidden"
                indicatorClassName="bg-darkPurple"
              />
            </>
          )
        ) : null}
      </CardHeader>

      {/* Card Content */}
      <CardContent>
        <div className="title font-semibold text-gray-700 text-lg break-words">
          {title}
        </div>
        <div className="missing-sec-info">
          <h1 className="text-gray-700 text-sm mt-2 mb-1">
            {title !== 'Plant Information' &&
            title !== 'Machines Information' ? (
              <p>Missing Information section:</p>
            ) : null}
            {progress === 100 ? <span className="py-2 "></span> : null}
          </h1>
          <p
            className={`text-gray-500 text-sm font-light ${title === 'Machines Information' || title === 'Plant Information' ? '' : 'max-h-10 overflow-hidden'}`}
          >
            {progress === 100 ? (
              'No missing fields'
            ) : (
              <span
                className={
                  title === 'Machines Information' ||
                  title === 'Plant Information'
                    ? 'text-gray-500 text-md font-light'
                    : ''
                }
              >
                {formatMissingFields(missingFields)}
              </span>
            )}
          </p>
          {progress === 100 ? <div className="py-2"></div> : null}

          {progress === 100 ? null : <Separator className="my-2" />}
        </div>
      </CardContent>

      {/* Card Footer */}
      <CardFooter>
        {progress < 100 ? (
          <Button
            className="w-full h-7 mb-2 rounded-lg bg-lightPurple hover:bg-darkPurple group"
            onClick={handleCompleteNow}
          >
            Complete Now
            <ArrowRight
              size={20}
              className="ml-2 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:scale-x-125"
            />
          </Button>
        ) : title === 'Plant Information' ||
          title === 'Machines Information' ? (
          <Button
            className="w-full h-7 mb-2 rounded-lg bg-lightPurple hover:bg-darkPurple group"
            onClick={handleCompleteNow}
          >
            Edit
            <Edit2
              size={20}
              className="ml-2 transition-transform duration-200 group-hover:rotate-360 cursor-pointer"
            />
          </Button>
        ) : null}
      </CardFooter>
    </Card>
  );
}
